import { computed } from "vue";
import { useRequirementsStore } from "@/stores";
import { orderTagDefs, TAG_SORT_ALPHABETICAL } from "@/utils/tags";
/** Orders tag definitions per the saved sort order: an explicit override, else the store's active-company config. */
export function useTagOrder(override) {
    const requirementsStore = useRequirementsStore();
    const sortOrder = computed(() => override?.value || requirementsStore.clientConfig?.tagSortOrder || TAG_SORT_ALPHABETICAL);
    const orderTags = (tagDefs) => orderTagDefs(tagDefs, sortOrder.value);
    return { sortOrder, orderTags };
}
